import { Pub, Service, Sub } from '../../../../../../shared/services/service.abstract.ts';
import { Observable, filter, map, switchMap } from 'rxjs';
import { gqlClient } from '../../../../../../graphql/graphqlRequest.ts';
import { getAIContentTranslation } from './gql/translation.gql.ts';
import {
  GetWa_AiContentTranslationQuery,
  GetWa_AiContentTranslationQueryVariables,
} from '../../../../../../graphql/generatedModel.ts';

type Actions = 'getAIContentTranslation' | undefined;

export interface IAiContentTranslationRequest {
  requestId: string;
  variables: GetWa_AiContentTranslationQueryVariables;
}

export interface IAiContentTranslationResponse {
  requestId: string;
  data: GetWa_AiContentTranslationQueryRes;
}

class PubImpl extends Pub<Actions> {
  getAIContentTranslation(params: IAiContentTranslationRequest) {
    this.emit('getAIContentTranslation', params);
  }

  clearStream() {
    this.emit(undefined, {});
  }
}

class SubImpl extends Sub<Actions> {
  getAIContentTranslation(): Observable<IAiContentTranslationResponse> {
    return this.actionListener('getAIContentTranslation').pipe(
      filter(({ params }) => {
        return !!params?.requestId && !!params?.variables;
      }),
      switchMap(({ params }) =>
        (
          gqlClient(
            getAIContentTranslation,
            params.variables,
          ) as Observable<GetWa_AiContentTranslationQuery>
        ).pipe(
          map((data) => ({
            requestId: params.requestId,
            data: data.wawiAssist?.getWA_AIContentTranslation as GetWa_AiContentTranslationQueryRes,
          })),
        ),
      ),
    );
  }
}

class TranslationService extends Service<Actions> {
  pub = new PubImpl(this.stream$);
  sub = new SubImpl(this.stream$);
}

export const translationService = new TranslationService();

export type GetWa_AiContentTranslationQueryRes = NonNullable<
  NonNullable<GetWa_AiContentTranslationQuery['wawiAssist']>['getWA_AIContentTranslation']
>;
